/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * Spare parts: leave them out of the regular product search by prepending window.theme.searchQueryPrefix (set in
 * layout/theme.liquid) to the submitted query. Forms marked with "data-spare-parts-search" are left untouched.
 *
 * This runs after the theme's own header handler, which may already have replaced the visible input by a hidden one.
 */
document.addEventListener('submit', function(event) {
  var form = event.target,
      prefix = window.theme.searchQueryPrefix;

  if (!prefix || event.defaultPrevented || form.hasAttribute('data-spare-parts-search')) {
    return;
  }

  if (new URL(form.action, window.location.origin).pathname !== window.routes.searchUrl) {
    return;
  }

  var typeInput = form.querySelector('input[name="type"]'),
      queryInput = form.querySelector('input[name="q"]');

  if (!queryInput || queryInput.value === '' || queryInput.value.indexOf(prefix) === 0 || (typeInput && typeInput.value.indexOf('product') === -1)) {
    return;
  }

  // We submit a hidden copy so the visible field never shows the prefix (for instance when coming back to the page)
  if (queryInput.type !== 'hidden') {
    var hiddenInput = queryInput.cloneNode();

    hiddenInput.type = 'hidden';
    queryInput.removeAttribute('name');
    queryInput.insertAdjacentElement('afterend', hiddenInput);
    queryInput = hiddenInput;
  }

  queryInput.value = prefix + queryInput.value;
});
